<template>
  <div id="grid-curso">
    <v-flex>
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text"
          >Recepción de Cuadraturas Curso</v-toolbar-title
        >
      </v-toolbar>
    </v-flex>
    <v-container grid-list-xl fluid>
      <v-layout>
        <carga-masiva-asincrona
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
          :tipoCarga="tipoCarga"
        ></carga-masiva-asincrona>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="datosPaginados"
              :page.sync="page"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              @page-count="pageCount = $event"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.idNivel }}</td>
                <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                <td class="text-xs-left">{{ props.item.total }}</td>
                <td>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Ver Cuadratura"
                    @click="
                      viewCuadratura(
                        props.item.id,
                        props.item.idNivel,
                        props.item.tipoPrueba
                      )
                    "
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>

            <!--  dsoto 10-11-2022 -->
            <v-flex xs12 sm6>
              <v-text-field
                value=""
                label="Total de Registros"
                v-model="cantRegistros"
                disabled
              ></v-text-field>
            </v-flex>
            <!--  dsoto 10-11-2022 -->

            <!--  dsoto 03-11-2022 -->
            <div class="text-center pt-2">
              <v-pagination
                @input="changePage(page)"
                v-model="page"
                :length="pageCount"
                :total-visible="9"
                circle
              >
              </v-pagination>
            </div>

            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                :loading="loading"
                :disabled="botonDescarga"
                color="primary"
                @click="descarga()"
                >Descarga Completa Cuadraturas</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
            <!-- dsoto 03-11-2022  paginacion  -->
          </template>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >Ver cuadratura
          </v-card-actions>

          <v-dialog v-model="dialogLoading" persistent max-width="390">
            <loading-descarga></loading-descarga>
          </v-dialog>
        </v-flex>
        <!-- nuevo modal proceso en curso (otro proceso se esta ejecutando, controlado por semaforo en controller!) -->
        <v-dialog v-model="procesoEnCurso" persistent max-width="600">
          <v-card>
            <v-card-title class="headline">Carga datos en proceso</v-card-title>
            <v-card-text>
              <v-flex lg12>
                <v-card-actions class="pb-3">
                  <v-spacer></v-spacer>
                </v-card-actions>
                <div class="text-resp text-xs-center">
                  <i
                    class="fa fa-pause-circle text-danger fa-5x pb-3"
                    aria-hidden="true"
                    style="color: #f9a825"
                  ></i
                  ><br />
                  <p>
                    <b>Otro proceso se está ejecutando en estos momentos.</b>
                  </p>
                  <p>Por favor espere unos minutos y vuelva a intentarlo.</p>
                  <v-btn color="primary" flat @click="cerrarModal()"
                    >Cerrar</v-btn
                  >
                </div>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import CargaMasivaAsincrona from "@/components/CargaMasivaAsincrona.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-curso",

  components: {
    AlertEmpty,
    Loading,
    CargaMasivaAsincrona,
    LoadingDescarga,
  },
  props: {
    rowsTable: String,
    tipeView: String,
  },

  data() {
    return {
      botonDescarga: true,
      procesoEnCurso: false,
      loading: false,
      loading1: false,
      alerta: false,
      dialog: false,
      dialogLoading: false,
      id: "",
      totalRegistro: "",
      rowsPerPageItems: [20],
      pagination: {
        page: 1,
        rowsPerPage: 50,
        pages: 0,
      },
      totalPages: 0,
      totalRegistros: "",
      idContrato: "",
      headers: [
        { text: "idNivel", align: "left", sortable: false, value: "rut" },
        { text: "Tipo Prueba", sortable: false, value: "candidato" },
        { text: "Total Registros", sortable: false, value: "evaluacion" },
        { text: "Accion", sortable: false, value: "" },
      ],
      usuarioLoggedTipe: "",
      itemsCuadratura: [],
      idUserLogged: "",
      proceso: "",
      nivelSelect: [],
      nivelValue: null,
      tipoPruebaSelect: [],
      tipoPruebaValue: null,
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
      tipoCarga: "CSV",

      // dsoto 08-11-2022
      page: 1,
      pageCount: 0,
      datosPaginados: [],
      paginaActual: 1,
      cantRegistros: 0,

      periodo: 0,
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;

    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;

    this.tab = this.$store.getters.subTabSelectedStored;

    //se indican las apis a utilizar
    this.apiValidateDocument = "/cuadraturas/preProcessFileCurso";
    this.apiSaveDocument = "/cuadraturas/saveFileMassiveCurso";
    this.apiDownloadDocument = "/cuadraturas/downloadTemplateCurso/";
    this.templateTitle = "Plantilla_Carga_Cuadraturas";

    this.loadPeriodo();
    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    async loadPeriodoById() {
      return await axios
        .get("/cuadraturas/getPeriodo/" + this.$store.getters.contratoStored)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return -1;
        });
    },
    async loadPeriodo() {
      this.periodo = await this.loadPeriodoById();
    },
    cerrarModal() {
      this.procesoEnCurso = false;
    },
    descarga() {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      let fileName = "Descarga_Cuadraturas_Curso.xlsx";
      let proceso = this.$store.getters.proSelectedStored;

      var url = "/cuadraturas/descargaCurso";
      if (this.periodo < 2020) {
        url = "/cuadraturas/descargaCursoAnt";
      }
      this.body = {
        idContrato: idContrato,
        proceso: proceso,
        idNivel: null,
        tipoPrueba: null,
      };
      axios
        .post(url, this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          if (error.response.status === 503) {
            this.procesoEnCurso = true;
            console.log("Otro proceso en ejecución");
          } else {
            // Otro tipo de error, manejar según sea necesario
            console.error("Error:", error.message);
            window.getApp.$emit("APP_PROCESS_ERROR", error.message);
          }

          // console.log("st::detalle:" + JSON.stringify(error, null, 2));
          console.log(error);
          return [];
        });
    },
    async loadScanFilter() {
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/cuadraturas/getSummaryCurso/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;

      this.itemsCuadratura = await this.loadScanFilter();

      if (this.itemsCuadratura.length > 0) {
        this.cantRegistros = this.itemsCuadratura.length; // dsoto 10-11-2022
        this.pageCount = Math.ceil(
          this.itemsCuadratura.length / this.rowsPerPageItems
        ); // dsoto 09-11-2022
        this.getDataPagina(this.page); // dsoto 09-11-2022

        this.loadNivelSelect();
        this.loadTipoPruebaSelect();
        this.alerta = false;
        this.botonDescarga = false;
      } else {
        this.botonDescarga = true;
        this.alerta = true;
      }
      // console.log("descarga:" + this.botonDescarga);
      this.loading = false;
    },
    loadNivelSelect() {
      let niv = [];
      this.itemsCuadratura.forEach(function (c) {
        let index = niv.findIndex((x) => x.nivel == c.nivel);
        if (index === -1) {
          if (c.nivel != null && c.nivel != "") {
            niv.push({ name: c.s_nivel, code: c.nivel });
          }
        }
      });
      this.nivelSelect = niv;
    },
    loadTipoPruebaSelect() {
      let tip = [];
      this.itemsCuadratura.forEach(function (d) {
        let index = tip.findIndex((x) => x.tipoPrueba == d.tipoPrueba);
        if (index === -1) {
          tip.push(d.tipoPrueba);
        }
      });
      this.tipoPruebaSelect = tip;
    },
    clear() {
      this.nivelValue = null;
      this.tipoPruebaValue = null;
      this.loadData();
    },
    filter() {
      this.loadData();
    },

    // dsoto 09-11-2022
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.getDataPagina(this.page);
    },

    getDataPagina(noPagina) {
      this.paginaActual = noPagina;
      this.datosPaginados = [];

      let ini = noPagina * this.rowsPerPageItems - this.rowsPerPageItems;
      let fin = noPagina * this.rowsPerPageItems;
      this.datosPaginados = this.itemsCuadratura.slice(ini, fin);
    },
    getDataFull() {
      this.datosPaginados = [];
      this.page = 1;
      this.datosPaginados = this.itemsCuadratura.slice(
        0,
        this.itemsCuadratura.length
      );
    },
    // dsoto 09-11-2022

    viewCuadratura(id, idNivel, tipoPrueba) {
      this.loading = true;
      var nombre = "GridCuadratura";
      if (this.periodo < 2020) {
        nombre = "GridCuadraturaAnt";
      }
      setTimeout(() => {
        this.$router.push({
          name: nombre,
          params: {
            id: id,
            tipeView: "consulta",
            idNivel: idNivel,
            tipoPrueba: tipoPrueba,
          },
        });
      }, 1000);
    },
    reload() {
      setTimeout(() => {
        this.$parent.$parent.reloadDocumento();
      }, 1000);
    },
  },
};
</script>
